import { Injectable } from '@angular/core';
import { RecorderService } from '@telespot/shared/session-recorder';
import { CookieService } from 'ngx-cookie-service';

import { cookiesData, ICookiesGroup } from '../config';

const COOKIES_DURATION_DAYS = 30;
@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private _cookieGroups: ICookiesGroup[];

  constructor(private recorderService: RecorderService, private cookies: CookieService) {
    this._cookieGroups = cookiesData.map((group) => ({
      ...group,
      items: group.items.map((item) => ({ ...item, accepted: this.getEnabled(item._key) ?? item.default })),
    }));
    this._cookieGroups.forEach(
      (cookieGroup) => (cookieGroup.allAccepted = cookieGroup.items.every((cookieItem) => cookieItem.accepted))
    );
  }

  public get cookieGroups(): ICookiesGroup[] {
    return this._cookieGroups;
  }

  public getEnabled(_key: string): boolean {
    return JSON.parse(localStorage.getItem(_key));
  }

  public setFullstoryEnabled(accepted: boolean) {
    this.recorderService.setConsent(accepted);
  }

  public hasUserPreferences(): boolean {
    const cookie = this.cookies.get('user_cookie_preferences_set');
    return !!cookie?.length;
  }

  public saveUserPreferences(): void {
    this.cookies.set('user_cookie_preferences_set', 'true', COOKIES_DURATION_DAYS);
  }
}
